
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[id]",
      function () {
        return require("private-next-pages/courses/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[id]"])
      });
    }
  